import { getOptions } from "@/interface/ShareWindow/constants";
import { PermissionSelect } from "@/interface/ShareWindow/PermissionSelect/PermissionSelect";
import {
    AccessEnum,
    type AccessOption,
    getAccessEnumTextExt,
    type MemberBoardData,
    type Option,
} from "@/interface/ShareWindow/types";
import styles from "./MemberAccessList.module.scss";

interface MemberAccessItemProps {
    member: MemberBoardData;
    handler: (e: Option, accountId: number) => void;
    canEdit?: boolean;
}

export const MemberAccessItem = ({ member, handler, canEdit }: MemberAccessItemProps) => {
    const memberName = member.name;
    const accessEnumToTextExt = getAccessEnumTextExt();
    const options = getOptions();

    return (
        <div className={styles.memberGrid}>
            <div className={styles.logo}>{memberName.substring(0, 1)}</div>

            <div className={styles.contact}>
                <p>{memberName}</p>
                <span>{member.email}</span>
            </div>

            <div></div>

            <div>
                {(member.access === AccessEnum.owner || !canEdit) && (
                    <div className={styles.owner}>
                        {accessEnumToTextExt[member.access as keyof typeof accessEnumToTextExt]}
                    </div>
                )}

                {member.access !== AccessEnum.owner && canEdit && (
                    <PermissionSelect<AccessOption>
                        options={options}
                        selectedValue={{
                            value: member.access as AccessOption,
                            label: accessEnumToTextExt[
                                member.access as keyof typeof accessEnumToTextExt
                            ],
                        }}
                        onChange={(e) => handler(e, member.accountId)}
                    />
                )}
            </div>
        </div>
    );
};
